import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { datePipe, getRandomColorWithOpacity } from '@piqet-angular/data';
import { reportTitals } from '@piqet-angular/shared';
import { ChartOptions } from 'chart.js';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';
@Component({
  selector: 'piqet-angular-simpale-deck-report',
  templateUrl: './simpale-deck-report.component.html',
  styleUrls: ['./simpale-deck-report.component.scss'],
})
export class SimpaleDeckReportComponent implements OnChanges, AfterViewInit {
  @Input() reportData: any;
  reportResource = reportTitals;
  mainProjectName!: string;
  remainingProjectName!: string;
  profilePic = './assets/images/defaultProfile.jpg';
  piqetLogo = './assets/images/Piqet_NewLogo.svg';
  organizationImage = './assets/images/GlobalWarming.png';
  spiderChartData: any = [];
  spiderChartLabels: string[] = [];
  spiderChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
      },
    },
    scales: {
      // y: {
      //   beginAtZero: true
      // },
      r: {
        alignToPixels: true,
        pointLabels: {
          display: false, // Hide point labels
        },
        ticks: {
          display: true, // Hide tick marks
          count: 3,
        },
      },
    },
    layout: {
      padding: {
        top: 100,
        right: 200,
        left: 150,
        bottom: 60,
      },
    },
  };
  doughnutChartPlugins = [
    {
      id: 'custom_labels',
      afterDraw: (chart: any, args: any) => {
        var image = new Image();
        // require for development When it will finished will remove
        // image.src = "https://piqet-angular.ifour-consultancy.net/assets/images/Piqet_NewLogo.png";
        if (image.complete) {
          const scale = chart.scales['r'];
          let counter = 0;
          for (const lable in this.spiderChartLabels) {
            this.drawTextAtIndex(
              this.chartImage[counter],
              scale,
              counter,
              this.spiderChartLabels[lable],
              counter
            );
            counter++;
          }
          // drawTextAtIndex(scale, 1, '3d_rotation', 'test1');
          // drawTextAtIndex(scale, 2, 'done', 'test2');
        } else {
          image.onload = () => chart.draw();
        }
      },
    },
  ];
  componentItems: any;
  chartImage: any;
  parentArr: any = [];
  componentItemsArray: any;
  indicatorImage: any;
  treeText: string = 'trees';
  equivalancyUnitlist: any = [];
  unit: number = 0;
  basetotal: any = [];
  imagelist: any;
  @Output() checkContent = new EventEmitter<{ projectName: any }>();

  constructor(private reportService: ReportsService) {}
  ngAfterViewInit() {
    setTimeout(() => {
      this.checkContent.emit({ projectName: this.reportData.projectName });
    }, 5000);
  }

  async ngOnChanges(changes: SimpleChanges) {
    this.reportData = changes['reportData'].currentValue;
    this.getRemainingText();
    if (this.reportData.spiderChartItems.scenarioListForAnnumImpact.length != 0) {
      this.indicatorImage =
        this.reportData.spiderChartItems.scenarioListForAnnumImpact[0].indicatorImageNameTable.split(
          ';'
        );
    }
    this.unit =
      this.reportData.spiderChartItems.scenarioListForAnnumImpact.length > 0
        ? this.reportData.spiderChartItems.scenarioListForAnnumImpact[0].numberofUnits
        : 0;
    if (this.reportData.spiderChartItems.scenarioListForAnnumImpact.length !== 0) {
      this.reportData.spiderChartItems.scenarioListForAnnumImpact.forEach((item: any) => {
        if (item.scenarioname === this.reportData.baseScenarioName) {
          this.basetotal = item.totals.split(';');
        }
      });
      this.imagelist =
        this.reportData.spiderChartItems.scenarioListForAnnumImpact[0].equivalencyImageTable.split(
          ';'
        );
      this.equivalancyUnitlist =
        this.reportData.spiderChartItems.scenarioListForAnnumImpact[0].indicatorEquivalancyUnits.split(
          ';'
        );
    }
    this.componentItemsArray = this.reportData.spiderChartItems.scenarioList;
    const holdingArr: any = [];
    if (this.reportData.spiderChartItems?.scenarioList?.length > 0) {
      this.componentItems = this.splitterFunc(
        this.reportData.spiderChartItems.scenarioList[0].indicators
      );
    }
    for (let i = 0; i < this.componentItems?.length; i++) {
      holdingArr.push([]);
    }
    this.parentArr = holdingArr;
    this.spiderChartLabels = this.componentItems;
    let chartData = await this.GetSpiderChart();
    this.spiderChartData = chartData;
  }

  splitterFunc(input: any) {
    return input.includes(';') ? input.split(';') : [input];
  }

  getImpact(impactValue: any) {
    let formattedImpact: string = '';

    if (impactValue) {
      const impact: number = parseFloat(impactValue);

      if (impact >= 100 || impact <= -100) {
        formattedImpact = Math.round(impact).toString();
      } else if (impact >= 1 || impact <= -1) {
        formattedImpact = impact.toFixed(1);
      } else if (impact >= 0.1 || impact <= -0.1) {
        formattedImpact = impact.toFixed(2);
      } else if (impact !== 0) {
        formattedImpact = impact.toExponential(2);
      } else {
        formattedImpact = '0';
      }
    }

    return formattedImpact;
  }

  GetSpiderChart() {
    let data: any = [];
    this.componentItemsArray.forEach((ele: any, i: any) => {
      let addObj: any = [];
      const splitArray = ele.totals.split(';');
      const randomColor = getRandomColorWithOpacity(0.1);
      const valuesArray = splitArray.map((data: any) => parseFloat(data).toFixed(2));
      this.chartImage = ele.indicatorImageName.split(';');
      addObj = {
        data: valuesArray,
        label: ele.scenarioname,
        backgroundColor: randomColor[i].rgba,
        borderColor: randomColor[i].rgb,
        borderWidth: '1.4',
        pointBackgroundColor: randomColor[i].rgba,
        pointBorderColor: randomColor[i].rgb,
      };
      data.push(addObj);
    });
    return data;
  }

  drawTextAtIndex(imageSrc: any, scale: any, index: any, text: any, counter: any) {
    const image = new Image();
    image.src = imageSrc;
    const offset = 48;
    const r = scale.drawingArea + offset;
    const angle = scale.getIndexAngle(index) - Math.PI / 2;
    const x = scale.xCenter + Math.cos(angle) * r;
    const y = scale.yCenter + Math.sin(angle) * r;
    const ctx = scale.ctx;
    ctx.save();
    ctx.translate(x, y);
    ctx.textAlign = 'center';
    ctx.font = '12px Neue Montreal, Arial, sans-serif';
    const lineHeight = 12; // Adjust this value as needed
    const lines = [];
    const words = text.split(' ');
    let currentLine = words[0];

    for (let i = 1; i < words.length; i++) {
      const word = words[i];
      const testLine = currentLine + ' ' + word;
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;
      const maxWidth = 100;

      if (testWidth <= maxWidth) {
        currentLine = testLine;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }

    lines.push(currentLine);

    // Calculate vertical position for centered text
    const textHeight = lines.length * lineHeight;
    const startY = -(textHeight / 2) + lineHeight / 2;

    if (this.spiderChartLabels.length < 15) {
      ctx.drawImage(image, -15, startY - 42, 30, 30);
    }

    ctx.fillStyle = 'black';

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      ctx.fillText(line, 0, startY + i * lineHeight);
    }

    ctx.restore();
  }

  getIndicatorName(indicatorId: any) {
    return this.reportData?.indicatorDetailList?.find((x: any) => x.Id === indicatorId)?.name || '';
  }

  generateImagePath(imageName: string): string {
    const queryParams = 'height=150&width=150&bgcolor=fff';
    const imagePath = !!imageName ? imageName : '';
    return `${imagePath}?${queryParams}`;
  }

  getRemainingText(): string {
    const parts = this.reportData?.projectName?.split(' - ');
    this.mainProjectName = parts[0];
    if (parts.length > 1) {
      this.remainingProjectName = parts.slice(1).join(' - ');
    }
    return '';
  }

  getTreeText(p: number): string {
    return p === 0 ? this.treeText : this.equivalancyUnitlist[p]?.toLowerCase();
  }

  getScenarioBasetotal(data: any) {
    return this.reportData?.spiderChartItems?.scenarioListForAnnumImpact[data]?.totals?.split(';');
  }

  getTotalImpact(p: any, scenarioImage: any) {
    const comparetotal = scenarioImage?.scenarioLists?.totals?.split(';');
    const value = Math.round(
      ((this.basetotal[p] * this.unit - comparetotal[p] * this.unit) /
        (this.basetotal[p] * this.unit)) *
        100
    );
    return Math.round(value);
  }

  getTotalImpactAbs(p: any, scenarioImage: any) {
    const comparetotal = scenarioImage?.scenarioLists?.totals?.split(';');
    const value = Math.round(
      Math.abs(
        ((this.basetotal[p] * this.unit - comparetotal[p] * this.unit) /
          (this.basetotal[p] * this.unit)) *
          100
      )
    );
    return Math.round(value);
  }

  getEuivalanceImpact(p: any, scenarioImage: any) {
    const comparetotalForImpact = scenarioImage?.scenarioLists?.totals?.split(';');
    const multiplier = scenarioImage?.scenarioLists?.multiplier?.split(';');
    return (this.basetotal[p] * this.unit - comparetotalForImpact[p] * this.unit) * multiplier[p];
  }

  getEuivalanceImpactAbs(p: any, scenarioImage: any) {
    const comparetotalForImpact = scenarioImage?.scenarioLists?.totals?.split(';');
    const multiplier = scenarioImage?.scenarioLists?.multiplier?.split(';');
    return (this.basetotal[p] * this.unit - comparetotalForImpact[p] * this.unit) * multiplier[p];
  }

  getFormateDate(date: any) {
    return datePipe(date);
  }
}
